import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileBottomNav, MobileNavDrawer } from "./MobileNav";
import { GlobalSearch } from "@/components/common/GlobalSearch";
import { IntegrationHealthBanner } from "@/components/common/IntegrationHealthBanner";

export function AppLayout() {
  return (
    <div className="flex min-h-screen bg-background print:min-h-0">
      {/* App chrome has no place on a printed page — pages that offer a
          Print button (e.g. Trip Detail) supply their own print layout via
          a `print:` block instead. */}
      <div className="print:hidden"><Sidebar /></div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="print:hidden"><Header /></div>
        {/* Above the content, not tucked into Settings: when the Bouncie
            grant dies the numbers on every page quietly stop updating, and
            the only way anyone found out last time was by comparing them
            against Bouncie's own app. */}
        <IntegrationHealthBanner />
        <main className="flex-1 pb-24 lg:pb-0 print:pb-0">
          <Outlet />
        </main>
      </div>
      <div className="print:hidden">
        <MobileBottomNav />
        <MobileNavDrawer />
        <GlobalSearch />
      </div>
    </div>
  );
}
